const modelContainer3d = document.querySelector('[data-name="model-container-3d"]');
const closeModel3dBtn = document.querySelector('[data-name="model-3d-close-btn"]');
const model3dDims = document.querySelectorAll('[data-name="model-dim"]');
const model3dDimLines = document.querySelector('[data-name="model-dim-lines"]');

function shom3Dmodel() {
  document.querySelector(".Model3DWrapper").classList.remove("HiddenModel");
  document.querySelector(".Model3DWrapper").classList.add("VisibleModelWrapper");
  document.querySelector('[data-name="model-3d-open-btn"]').classList.add("HiddenBtn");
  document.documentElement.classList.add("lock");
}

function hide3Dmodel() {
  document.querySelector('[data-name="model-3d-open-btn"]').classList.remove("HiddenBtn");
  document.querySelector(".Model3DWrapper").classList.remove("VisibleModelWrapper");
  document.querySelector(".Model3DWrapper").classList.add("HiddenModel");
  document.documentElement.classList.remove("lock");
}

document.addEventListener("keydown", function(event) {
  if (event.key === "Escape") {
    hide3Dmodel();
  }
});

function showModelDimensions() {
  model3dDims.forEach((dim) => {
    dim.classList.add("ShowDimensions");
  });
  model3dDimLines.classList.add("ShowDimensions");
}
if (modelContainer3d) {
  modelContainer3d.addEventListener("mousedown", showModelDimensions);
  modelContainer3d.addEventListener("touchstart", showModelDimensions);
}
